export interface SendLogResponse {
    sendLog: boolean
}

export const SEND_LOG =  `
    query SendLog($message: String!, $jsonStringifiedString: String!, $pageUrl: String!) {
        sendLog(
            input: {
                applicationId: "",
                message: $message,
                JSONStringifiedString: $jsonStringifiedString,
                additionalInfo: { pageUrl: $pageUrl }
            }
        )
    }`;
